import mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'

const state = {
    activeThirdPartyPartners: [],
    allThirdPartyPartners: [],
    selectedThirdPartyPartner: {}
}

export default {
    state,
    mutations,
    actions,
    getters
}


// WEBPACK FOOTER //
// ./src/store/modules/thirdparty/index.js